import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <h3>🍪 Cookie Notice</h3>
          <p>
            We use essential cookies to provide basic functionality and authentication.
            By using this site, you agree to our use of cookies for storing your login session
            and user preferences.
          </p>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
            We do not use tracking or advertising cookies.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="btn-primary">
            Accept
          </button>
          <button onClick={handleDecline} className="btn-secondary">
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
